<!-- Actions for Agreement Edits page -->
<template>
	<div>
		<div class="text-center mt-1" v-if="this.user_role !== 'guest'">
			<div class="inline-flex">
				<vx-tooltip :text="'View'" position="bottom" class="inline-flex mr-2 cursor-pointer">
					<feather-icon icon="EyeIcon" :svgClasses="`action-icons cursor-pointer h-4 w-4`" @click="viewAgreement()"/>
				</vx-tooltip>

				<span class="br-line mr-2 ml-2"></span>
			</div>


			<div v-if="this.params.data.status == 'edit approved' || this.params.data.status == 'creation-pending' || this.params.data.status == 'edit-pending' || this.params.data.status == 'active'" class="inline-flex cursor-not-allowed">
				<vx-tooltip :text="'Edit'" position="bottom" class="inline-flex ml-2 cursor-pointer">
			  	<feather-icon icon="EditIcon" :svgClasses="`action-icons disabled`"/>
				</vx-tooltip>
			</div>
			<div v-else class="inline-flex" :class="user_role =='demo' ? 'disabled' : ''">
			  <vx-tooltip :text="'Edit'" position="bottom" class="inline-flex ml-2 cursor-pointer">
				  <feather-icon icon="EditIcon" :svgClasses="`action-icons cursor-pointer h-4 w-4`" @click="editAgreement()"/>
			  </vx-tooltip>
			</div>
		</div>	
	</div>	
</template>

<script>
	export default {
		name: 'CellRendererViewAndEditActions',
		data() {
			return {  				 
			}
		},
		computed: {   
			user_role(){
								return JSON.parse(localStorage.getItem("userDetails")).role;
			}         
		},
		methods: {
			viewAgreement(){
				var rowData = this.params;
				this.$root.$emit('openEditAgtPopup', 'view', rowData.data.id, rowData.data);
			},
			editAgreement(){
				var rowData = this.params;
				let mode = rowData.data.approved_at ? 'edit' : 'req-edit';
				this.$root.$emit('openEditAgtPopup', mode, rowData.data.id, rowData.data);
			},
		},
	}
</script>
<style lang="scss">
  .disabled{
		pointer-events: none;
        opacity: 0.4;
	}

	.action-icons {
		height: 16px;
		width: 16px;
	}
</style>